import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { ApiService } from '../../shared/services/api.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class PlanSelectionGuard implements CanActivate {
  constructor(
    private readonly authService: AuthService,
    private readonly apiService: ApiService,
    private readonly router: Router
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.authService.user$.pipe(
      take(1),
      switchMap((user) => {
        if (!user) return of(true);

        return this.apiService.getCurrentUserProfile().pipe(
          map((profile) => {
            const profileUser = profile.user;
            const needsTeamBillingSetup =
              profileUser.role === 'admin' &&
              profileUser.enabled === true &&
              profileUser.team === true &&
              profileUser.isBillingOwner === true &&
              profileUser.requiresTeamBillingSetup === true;
            if (needsTeamBillingSetup && !state.url.startsWith('/billing/plan-selector')) {
              return this.router.parseUrl('/billing/plan-selector?scope=team');
            }
            if (user.role !== 'user') {
              return true;
            }
            const needsPlanSelection =
              profileUser.enabled === true &&
              profileUser.team !== true &&
              profileUser.approvalStatus === 'APPROVED' &&
              !profileUser.selectedPlanId;

            if (needsPlanSelection) {
              return this.router.parseUrl('/billing/plan-selector');
            }
            return true;
          }),
          // Do not lock users out on transient profile fetch failures.
          catchError(() => of(true))
        );
      })
    );
  }
}
